import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
    marginBottom: theme.spacing(-2),
  },
  currency: {
    color: theme.palette.labraText.description,
    lineHeight: '20px',
    fontSize: '14px',
  },
  amount: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'right',
  },
  titleRight: {
    display: 'flex',
    width: '100%',
    justifyContent: 'right',
  },
}))
